import { StepName } from '|/app/services';
import {
  useBAVPartialCompletion,
  useIncomePartialCompletion,
  useAddressPartialCompletion,
  useTradeVerificationPartialCompletion,
  useAdditionalIncomePartialCompletion
} from './stubs';

/**
 * Dispatcher: given the ID of the current incomplete verification step,
 * returns a partial-completion status string or null (not started / unknown).
 * Called in useVerificationsVm when task sheet closes via X.
 */
const usePartialCompletion = (stepId: StepName | null): string | null => {
  const bav = useBAVPartialCompletion(stepId ?? StepName.BAV);
  const income = useIncomePartialCompletion(stepId ?? StepName.Income);
  const address = useAddressPartialCompletion(stepId ?? StepName.Address);
  const trade = useTradeVerificationPartialCompletion(stepId ?? StepName.TradeVerification);
  const addIncome = useAdditionalIncomePartialCompletion(stepId ?? StepName.AdditionalIncome);

  if (stepId === null) return null;
  switch (stepId) {
    case StepName.BAV:
      return bav;
    case StepName.Income:
      return income;
    case StepName.Address:
      return address;
    case StepName.TradeVerification:
      return trade;
    case StepName.AdditionalIncome:
      return addIncome;
    default:
      return null;
  }
};

export default usePartialCompletion;
